import { render, staticRenderFns } from "./PIconBtn.vue?vue&type=template&id=6d22126c"
import script from "./PIconBtn.vue?vue&type=script&lang=js"
export * from "./PIconBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports